import onResize from '../utils/onResize';
import emitter from './emitter';

let menuOpen = false;

const toggleMenu = () => {
    // ie11 don't support classlist.toggle so roll our own.
    const func = menuOpen ? 'remove' : 'add';
    document.documentElement.classList[func]('profile-menu-open');
    menuOpen = !menuOpen;
};

const closeMenu = () => {
    if (menuOpen) {
        toggleMenu();
    }
};

const registerMenuToggles = () => {
    [...document.querySelectorAll('.profile-menu-toggle')].forEach(el => {
        el.addEventListener('click', toggleMenu);
    });
};

export default function initMainMenu() {
    registerMenuToggles();
    onResize(closeMenu);
    emitter.on('mobile-menu:close', closeMenu);
}
